import { render, staticRenderFns } from "./MultiplePay.vue?vue&type=template&id=4a584dd2&scoped=true&"
import script from "./MultiplePay.vue?vue&type=script&lang=js&"
export * from "./MultiplePay.vue?vue&type=script&lang=js&"
import style0 from "./MultiplePay.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MultiplePay.vue?vue&type=style&index=1&id=4a584dd2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a584dd2",
  null
  
)

export default component.exports